<ng-container *ngIf="supportsIE === true">
  <!--The content below is only a placeholder and can be replaced.-->
  <app-header [hidden]="baseComponent.hideHeader"></app-header>

  <!-- <bootstrap-growl [alertCount]="3" [autoClose]="5"></bootstrap-growl> -->

  <div class="all-content">
    <router-outlet></router-outlet>
  </div>

  <app-footer [hidden]="baseComponent.hideFooter"></app-footer>
</ng-container>

<ng-container *ngIf="supportsIE == false">
  <div>This browser is <strong>NOT</strong> supported. Please use a browser such as Chrome, Firefox, Edge, or Safari.</div>
</ng-container>
